<template>
  <div>
    <h1>Support</h1>
    <div>
      If you have any questions or need assistance, please email us<br>
      <a href="mailto:inertry@gmail.com">inertry@gmail.com</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'support-page'

}
</script>

<style lang="css" scoped>
.counter-number {
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/SupportPage.vue